<template>
  <div class="py-4 container-fluid">
    <div class="row align-items-center mb-4">
      <div class="col-lg-3 col-sm-12">
        <div class="nav-wrapper position-relative end-0">
          <ul class="nav nav-pills nav-fill p-1" role="tablist">
            <li v-bind:key="category" class="nav-item">
              <a @click="llamadaDashboard()"
                class="nav-link mb-0 px-0 py-1 active active"
                data-bs-toggle="tab"
                role="tab"
                aria-selected="true"
                style="cursor: pointer;"
                >Dashboard</a
              >
            </li>
            <li class="nav-item">
              <a @click="reports()"
                class="nav-link mb-0 px-0 py-1 active active"
                data-bs-toggle="tab"
                role="tab"
                aria-selected="false"
                style="cursor: pointer;"
                >Reports</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row" v-if="dashboard">
      <div class="col-sm-12 mb-4">
        <div class="card">
          <div id="menuSup" class="card-body" style="display: flex; justify-content: space-between; gap: 15px; align-items: center;">
            <div style="flex: 1; display: flex; gap: 15px; align-items: center; width: 100%;">
              <SoftProgress style="flex: 1;" :color="success" :percentage="percentage" />
              <p style="flex: 1; margin: 0;" class="text-sm text-capitalize font-weight-bold">
                Messages generated <span>{{ K.fNumber(messages_sent) }}</span>/<span style="color: #cb0c9f;font-weight: 600;">{{ K.fNumber(tope) }}</span>
              </p>
            </div>
            <span style="cursor: pointer; flex: 1; text-align: right;" class="text-sm text-capitalize font-weight-bold" @click="K.downloadData(this.dataDownload)">
              Download dashboard data <i class="fa fa-download" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div> 
       

      <div v-show="!loading" class="col-xl-3 col-sm-6 mb-xl-0">
        
        <mini-statistics-card
          title="Messages sent today" 
          :value="K.fNumber(emailsSentToday)"
          :percentage="{
            value: '+505%',
            color: 'text-success',
          }" 
          :icon="{
            component: 'ni ni-chat-round',
            background: iconBackground,
          }"
          direction-reverse
        />
        <mini-statistics-card
          title="Messages sent this month" 
          :value="K.fNumber(emailsSentMonth)"
          :percentage="{
            value: '+505%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-email-83',
            background: iconBackground,
          }"
          direction-reverse
        />
        <mini-statistics-card
          title="Teams" 
          :value="K.fNumber(collections)"
          :percentage="{
            value: '+505%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-folder-17',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div v-show="!loading" class="col-xl-3 col-sm-6 mb-xl-0">
        <mini-statistics-card
          title="Saved hours"
          :value="K.fNumber(savedHours)"
          :percentage="{
            value: '+5%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-watch-time',
            background: iconBackground,
          }"
          direction-reverse
        />
        <mini-statistics-card
          title="Registered emails"
          :value="K.fNumber(emailsRegistered)"
          :percentage="{
            value: '+5%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-archive-2',
            background: iconBackground,
          }"
          direction-reverse
        />
        <mini-statistics-card
          title="Total users"
          :value="K.fNumber(user)"
          :percentage="{
            value: '+5%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-single-02',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div v-show="loading" class="card col-xl-6 col-sm-6 mb-4">
        <div class="p-3 card-body">
          <div class="chart">
            <div style="display: flex; align-items: center; justify-content: center; gap: 5px;">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-xl-6 col-sm-12 mb-4">
        <div class="card z-index-2">
          <div v-show="!loading" class="p-3 pb-0 card-header" style="display: flex; justify-content: space-between; align-items: flex-start;">
            <h6>Created mails</h6>
          </div>
          <div v-show="!loading" class="p-3 card-body">
            <div class="chart">
              <canvas id="linechartCanvas" class="chart-canvas" height="207"></canvas>
            </div>
          </div>
          <div v-show="loading" class="p-3 card-body">
            <div class="chart">
              <div style="display: flex; align-items: center; justify-content: center; gap: 5px;">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-4" style="overflow-x: auto; padding-bottom: 10px;">
        <div v-show="!loading" style="display: flex; gap: 10px; min-width: 800px !important;">
          <place-holder-card style="width: 180px; height: 152.09px;" 
          data-bs-toggle="modal" 
          data-bs-target="#teamModal" :title="{ variant: 'h5', text: 'New team' }" />

          <default-info-card
            @delete="openDeleteTeam"
            @select="selectTeam"
            v-for="(collection, index) of table_collections"
            :key="index"
            style="width: 180px;"
            icon="text-white fas fa-landmark"
            :title="collection.name"
            :value="K.fNumber(collection.emails)"
            :token="collection.token"
          />
        </div>
        
        <div v-show="loading" class="card">
          <div style="justify-content: center; padding: 15px; display: flex; align-items: center;">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
        </div>
        
      </div>

      <soft-alert v-show="teamNotDeleted === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>Error</strong> Could not delete the team
      </soft-alert>
      <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
        <strong>{{ responseMessage }}</strong>
      </soft-alert>
      <soft-alert v-show="teamDeleted === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
        <strong>Success</strong> Team deleted!
      </soft-alert>
      
      <div class="col-lg-12 mb-md-0 mb-4">
        <activityTable v-show="!loading" @traerdata="llamadaDashboard" :datos="tableData" />
        <div v-show="loading" class="card">
          <div style="justify-content: center; padding: 15px; display: flex; align-items: center;">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <reports></reports>
    </div>

    <!-- Modal New Team-->
    <div class="modal fade" data-bs-backdrop="static" id="teamModal" tabindex="-1" aria-labelledby="teamModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="teamModalLabel">New team</h5>
            
          </div>
          <div class="modal-body">
            <label>Team's name</label>
            <input
              id="name"
              type="text"
              class="form-control"
              name="Name"
              v-model="name"
              placeholder="Sales team"
              isRequired="required"
            />
            
          </div>
          <div class="modal-footer">
            <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton @click="newTeam()" data-bs-dismiss="modal">Save changes</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Delete Team-->
    <div class="modal fade" data-bs-backdrop="static" id="idDeleteTeam" tabindex="-1" aria-labelledby="deleteTeamLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteTeamLabel">Delete team</h5>
            
          </div>
          <div class="modal-body">
            Your are about to delete a team
          </div>
          <div class="modal-footer">
            <SoftButton color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton color="danger" @click="deleteTeam()" data-bs-dismiss="modal">Delete</SoftButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import setNavPills from "@/assets/js/nav-pills.js";
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import DefaultInfoCard from "@/examples/Cards/DefaultInfoCard.vue";
import PlaceHolderCard from "@/examples/Cards/PlaceHolderCard.vue";
import activityTable from "./components/activityTable.vue";
import reports from "../views/components/_reports.vue";
import SoftButton from "../components/SoftButton.vue"
import SoftProgress from "../components/SoftProgress.vue"
import SoftAlert from "../components/SoftAlert.vue"
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
//import * as am4core from "@amcharts/amcharts4/core";
//import * as am4charts from "@amcharts/amcharts4/charts";
//import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Chart from "chart.js/auto";

//am4core.unuseTheme(am4themes_animated);

export default {

  name: "dashboard-default",

  data() {
    return {
      dashboard: true,
      llamada: new HTFetch(),
      K: new K(),
      dataDownload: [],
      dataLinechart: [],
      tableData: [],
      emailsSentToday: 0,
      emailsRegistered: 0,
      emailsSentMonth: 0,
      savedHours: 0,
      collections: 0,
      users: 0,
      linechartDates: [],
      linechartValues: [],
      iconBackground: "bg-gradient-success",
      chart: {},
      loading: false,
      name: "",
      table_collections: [],
      tokenDelete: "",
      nameDelete: "",
      teamDeleted: false,
      teamNotDeleted: false,
      responseMessage: "",
      showResponseMessage: false,
      percentage: 0,
      messages_sent: 0,
      tope: 0,
    };
  },

  components: {
    MiniStatisticsCard,
    activityTable,
    DefaultInfoCard,
    PlaceHolderCard,
    SoftButton,
    SoftAlert,
    SoftProgress,
    reports
  },

  mounted() {
    setTooltip();
    setNavPills();

    this.llamadaDashboard()
    this.llamada.userInfo(this.userInfoRsp.bind(this))

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "dashboard",
        user_id: localStorage.userId
      });
    }
  },

  methods: {

    llamadaDashboard() {
      this.dashboard = true
      this.llamada.dashboard(this.dashboardRsp.bind(this))
      this.loading = true
    },

    dashboardRsp(rsp) {
      console.log(rsp)
      if (rsp.status === 400 || rsp.status === 401 || rsp.status === 403) {
        return
      }

      this.dataDownload = rsp.data

      this.user = rsp.data.data_blocks.users;
      this.emailsRegistered = rsp.data.data_blocks.registered_emails;
      this.emailsSentMonth = rsp.data.data_blocks.emails_this_month;
      this.emailsSentToday = rsp.data.data_blocks.emails_today;
      this.collections = rsp.data.data_blocks.collections;
      this.savedHours = rsp.data.data_blocks.saved_hours;
      this.tableData = rsp.data.table_user;
      this.dataLinechart = rsp.data.linechart;
      this.table_collections = rsp.data.table_collections;

      const fechas = rsp.data.linechart.map(obj => obj.fecha);
      const valors = rsp.data.linechart.map(obj => obj.generaciones);
      this.loading = false;

      this.dibuja(rsp.data.linechart, fechas, valors)

    },

      dibuja(datitos, fechas, valors) {
        var ctx = document.getElementById('linechartCanvas').getContext("2d");

        var gradientStroke1 = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke1.addColorStop(1, "rgba(203,12,159,0.2)");
        gradientStroke1.addColorStop(0.2, "rgba(72,72,176,0.0)");
        gradientStroke1.addColorStop(0, "rgba(203,12,159,0)");

        let chartStatus = Chart.getChart('linechartCanvas');
        if (chartStatus != undefined) {
          chartStatus.destroy();
        }

        new Chart(ctx, {
          type: "line",
          data: {
            labels: /*this.chart.labels*/fechas.reverse(),
            datasets: [
              {
                label: /*this.chart.datasets[0].label*/'Created mails',
                tension: 0.4,
                borderWidth: 0,
                pointRadius: 0,
                borderColor: "#cb0c9f",
                // eslint-disable-next-line no-dupe-keys
                borderWidth: 3,
                backgroundColor: gradientStroke1,
                fill: true,
                data: /*this.chart.datasets[0].data*/valors.reverse(),
                maxBarThickness: 6,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
            interaction: {
              intersect: false,
              mode: "index",
            },
            scales: {
              y: {
                grid: {
                  drawBorder: false,
                  display: true,
                  drawOnChartArea: true,
                  drawTicks: false,
                  borderDash: [5, 5],
                },
                ticks: {
                  display: true,
                  padding: 10,
                  color: "#b2b9bf",
                  font: {
                    size: 11,
                    family: "Open Sans",
                    style: "normal",
                    lineHeight: 2,
                  },
                },
              },
              x: {
                grid: {
                  drawBorder: false,
                  display: false,
                  drawOnChartArea: false,
                  drawTicks: false,
                  borderDash: [5, 5],
                },
                ticks: {
                  display: true,
                  color: "#b2b9bf",
                  padding: 10,
                  font: {
                    size: 11,
                    family: "Open Sans",
                    style: "normal",
                    lineHeight: 2,
                  },
                },
              },
            },
          },
        });
      },

      newTeam() {
        let body = {
          "name": this.name
        }

        this.llamada.newTeam(body, this.newTeamRsp.bind(this))
      },

      newTeamRsp(rsp) {
        
        if (399 < rsp.status && rsp.status < 501) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('name' in rsp.data) {
            this.responseMessage = "Name: " + rsp.data.name.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)

          return
        }

        this.name = ""
        this.llamadaDashboard()
        this.llamada.userInfo(this.userInfoRsp.bind(this))
      },

      userInfoRsp(rsp) {
        let collecciones = []
        for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
          collecciones.push({
            "name": Object.keys(rsp.data.collections)[i],
            "token": Object.values(rsp.data.collections)[i]
          })
        }

        localStorage.collections = JSON.stringify(collecciones)

        localStorage.userId = rsp.data.token

        this.tope = rsp.data.limit_generations
        this.messages_sent = rsp.data.count_generations
        this.percentage = (this.messages_sent/this.tope)*100
      },

      openDeleteTeam(name, token) {
        this.tokenDelete = token;
        this.nameDelete = name;
      },

      deleteTeam() {
        
        let body = {
          "name": this.nameDelete,
          "token": this.tokenDelete
        }

        this.llamada.deleteTeam(body, this.deleteTeamRsp.bind(this))
      },

      deleteTeamRsp(rsp) {

        if (399 < rsp.status && rsp.status < 501) {
          
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)

          return
        }
        
        if (rsp.data.message === 'Deleted') {
          this.teamDeleted = true

          setTimeout(() => {
            this.teamDeleted = false
          }, 2000)

          this.llamadaDashboard()
          this.llamada.userInfo(this.userInfoRsp.bind(this))
        }
      },

      selectTeam(token) {
        console.log(token)
      },

      reports() {
        this.dashboard = false
      }
  }
};
</script>
<style scoped>

@media (max-width: 460px) {
  #menuSup {
    flex-direction: column;
  }
}

</style>